import { Navigate, useLocation } from "react-router-dom";
import { usePasswordConfirm } from "@/context/PasswordConfirmContext";

interface ProtectedAccountRouteProps {
  children: React.ReactNode;
}

const ProtectedAccountRoute = ({ children }: ProtectedAccountRouteProps) => {
  const { isPasswordConfirmed } = usePasswordConfirm();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const isEmailConfirmation =
    searchParams.get("type") === "change-email" && searchParams.get("token");

  if (isEmailConfirmation) {
    return <>{children}</>;
  }

  if (!isPasswordConfirmed) {
    return (
      <Navigate
        to={"/settings/account/confirm-password"}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedAccountRoute;
